import { Typography, TextField, Button, Grid, Box } from '@mui/material';
import { createContext, useContext } from "react";
import { ContextSession } from '../../services/ContextSession';
import imagen from '../RNP/2541182.png'
import imagen2 from '../../img/7466140.png'
import './fichadni.component.css';

export default function FichaDefuncion({ dniData }) {
    const { sessionData } = useContext(ContextSession);
    //const { nombre, apellido } = sessionData;
    const fechaDefuncion = dniData?.fechadedefuncion;

    return (
        <>
            {
                dniData && !dniData.error ? (
                    <div className="ficha">
                        <div className="imagen">
                            <div className="watermark-container">
                                <div className="image-overlay"></div> {/* Elemento superpuesto */}
                                <img
                                    src={imagen}
                                    alt="Defunción"
                                />
                            </div>
                        </div>
                        <div className="datos-container">
                            <div className="datos">
                                <div className="seccion">
                                    <h2>Defunción</h2>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="etiqueta1">Nombres:</td>
                                                <td className="valor1">{dniData.nombres}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">Apellidos:</td>
                                                <td className="valor">{dniData.primerapellido} {dniData.segundoapellido}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Numero Tomo:</td>
                                                <td className="valor1">{dniData.numerotomo}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">Número Folio:</td>
                                                <td className="valor">{dniData.numerofolio}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Fecha De Defunción:</td>
                                                <td className="valor1">{fechaDefuncion}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">País Defunción:</td>
                                                <td className="valor">{dniData.paisdefuncion}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Departamento Defunción:</td>
                                                <td className="valor1">{dniData.deptodefuncion}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">Municipio Defunción:</td>
                                                <td className="valor">{dniData.munidefuncion}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Lugar Defunción:</td>
                                                <td className="valor1">{dniData.lugardefuncion}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">Fecha Entierro:</td>
                                                <td className="valor">{dniData.fechaentierro}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Lugar Entierro:</td>
                                                <td className="valor1">{dniData.lugarentierro}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">Fecha Registro:</td>
                                                <td className="valor">{dniData.fecharegistro}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="ficha">
                        <div className="imagen">
                            <div className="watermark-container">
                                <div className="image-overlay"></div> {/* Elemento superpuesto */}
                                <img
                                    src={imagen2}
                                    alt="Defunción"
                                />
                            </div>
                        </div>
                        <div className="datos-container">
                            <div className="datos">
                                <div className="seccion">
                                    <h2>Defunción</h2>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="valor1" align='center'>No se encontró acta de defunción para esta persona</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
}


